module.exports = __webpack_public_path__ + "img/l1.0b1f7022.png";